export const formatUKNumber = (num: string) => {
  if (num.startsWith('44')) {
    return `0${num.substring(2)}`
  }
  if (num.startsWith('7') && num.length >= 10) {
    return `0${num}`
  }
  if (num.startsWith('07')) {
    return num
  }
  return num
}

export const formatUKNumberWithCountryCode = (num: string) => {
  if (num.startsWith('44')) {
    return num
  }
  if (num.startsWith('7') && num.length >= 10) {
    return `44${num}`
  }
  if (num.startsWith('07')) {
    return `44${num.substring(1)}`
  }
  return num
}

export const numbersOnly = (value: string) => value.replace(/[\D]+/gi, '')
